import React from "react";
import { Button, message, Input, Menu, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useWorkHourModel } from "../workHourModel";
import useNavModel from "@/model/navModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
export const DataBox = () => {
    const { exportData } = useWorkHourModel();

    const action = <>
        <YhAuth resCode={ResourceAuthEnum.VRM2_STT_TIMETOTAL_EX}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => exportData()}
            >导出</Button>
        </YhAuth>
    </>;

    return (
        <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
            <DataTable />
        </YhBox>
    )
}